// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_VEHICLE_ACCOUNT,
  EDIT_VEHICLE_ACCOUNT_MASTER,
  GET_VEHICLE_ACCOUNT_BYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { useModalContext } from "../../Reactportal/ModalContext";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddFlightMaster = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}: {
  show: boolean;
  TypeOfPortal: string;
  submitType: string;
  ParentPortalCloseFunction: () => void;
  ReferenceFieldName?: any;
  ReferFormKey?: string;
}) => {
  
const { pushModal, popModal } = useModalContext();
const [isFirstLoad, setFirstLoad] = useState(false);
  const Form_Key = TypeOfPortal === "Merge" ? "Flight_Master_Merge" : "Flight_Master";
  const formRef = useRef({});
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const [DepartureTime, setDepartureTime] = useState("");
  const [ArrivalTime, setArrivalTime] = useState("");
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Flight_Master?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [SelectedWeekDays, setSelectedWeekDays] = useState<String[]>([]);
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: CreatingFlight }] = useMutation(CREATE_VEHICLE_ACCOUNT);

  const [getDataById, { loading: getDataByIdLoader }] = useLazyQuery(GET_VEHICLE_ACCOUNT_BYID, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: EditingFlight }] = useMutation(EDIT_VEHICLE_ACCOUNT_MASTER);

  const FlightLoading = CreatingFlight || EditingFlight || getDataByIdLoader;

  let WeekArr = [
    { Name: "Mon", Day: "Monday" },
    { Name: "Tue", Day: "Tuesday" },
    { Name: "Wed", Day: "Wednesday" },
    { Name: "Thu", Day: "Thursday" },
    { Name: "Fri", Day: "Friday" },
    { Name: "Sat", Day: "Saturday" },
    { Name: "Sun", Day: "Sunday" },
  ];

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const toggleWeekDay = (day) => {
    setSelectedWeekDays((prevState: any) => {
      if (prevState.includes(day)) {
        // Remove the day if it's already in the array
        return prevState.filter((item) => item !== day);
      } else {
        // Add the day if it's not in the array
        return [...prevState, day];
      }
    });
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };
  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Flight_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        getDataById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let TrainData = { ...data?.getVehicleMasterById };
          setDepartureTime(TrainData?.Departure_Time);
          setArrivalTime(TrainData?.Arrival_Time);
          setSelectedWeekDays(TrainData?.Frequency);
          setAllFieldsData(TrainData);
          updateValueForm(formRef, TrainData);
        });
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };


  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation }: { executeOperation: any } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
  };

  const submit = async (closeAction) => {
    formData.Departure_Time = DepartureTime;
    formData.Arrival_Time = ArrivalTime;
    formData.Frequency = SelectedWeekDays;
    formData.Type = "Flight";
    let Name = ReferenceFieldName[0]?.name;
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res: any) => {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createPart_Master || res?.data?.editPart_Master,
              },
            },
          });
          if (TypeOfPortal === "Add") {
            setDepartureTime("");
            setArrivalTime("");
            setSelectedWeekDays([]);
          }
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    setAllFieldsData({});
    setDepartureTime("");
    setArrivalTime("");
    setSelectedWeekDays([]);
    ClearSpecificForm(dispatch, Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
            ? () => ConfirmModalOpen()
            : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={FlightLoading}
    />
  );

  return (
    <>
      <Reactportal
        FoooterContent={footerContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal + " Flight Master"}
      >
        {FlightLoading && <div className="loader-line-div" />}
        <div className="mainContainer">
          {inputFields && inputFields?.length > 0 ? (
            inputFields.map((e: any) => (
              <div key={e.id} className="FormSectionParent">
                <div className="FormSection insidecontainer">
                  <FormInputSectionComponent
                    inputfields={e.fields}
                    Type={e.name}
                    fielddata={allFieldsData}
                    validation_Schema={e.Valid_schema}
                    onErrorsChange={handleErrorsChange}
                    formkey={Form_Key}
                    formRef={formRef}
                    onhandleFormikChange={HanldeChangeonForm}
                    setFirstLoad={setFirstLoad}
                  />
                </div>
              </div>
            ))
          ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
            <p style={{ textAlign: "center" }}>No form fields available.</p>
          ) : null}
          {TypeOfPortal !== "Merge" && (
            <>
              <div className="TravelTimePick">
                <div>
                  <label htmlFor="" className="form__label">
                    Departure Time
                  </label>
                  <input
                    aria-label="Time"
                    type="time"
                    className="TimeField"
                    value={DepartureTime}
                    onChange={(e) => setDepartureTime(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="" className="form__label">
                    Arrival Time
                  </label>
                  <input
                    aria-label="Time"
                    type="time"
                    className="TimeField"
                    value={ArrivalTime}
                    onChange={(e) => setArrivalTime(e.target.value)}
                  />
                </div>
              </div>
              <label htmlFor="" className="form__label" style={{ marginLeft: "20px" }}>
                Select Frequency
              </label>
              <div className="weeks">
                {WeekArr &&
                  WeekArr.map((e) => (
                    <>
                      <div className="checkboxDiv">
                        <p>{e.Name}</p>
                        <input
                          onChange={() => toggleWeekDay(e.Name)}
                          type="checkbox"
                          className="inputcheckboxcss"
                          checked={SelectedWeekDays?.includes(e?.Name)}
                          disabled={false}
                        />
                      </div>
                    </>
                  ))}
              </div>
            </>
          )}
        </div>
      </Reactportal>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={FlightLoading}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
        />
      )}
    </>
  );
};

export default AddFlightMaster;
